const i18n = {
  'en-US': {
    'menu.dashboard': 'Dashboard',
    'menu.dashboard.workplace': 'Workplace',
    'menu.data.memory': 'Memories & Profiles',
    'menu.data.conversation': 'Conversations & Archive',
    'menu.data.device': 'Devices & Faces',
    'menu.data.actions': 'Cloud Actions',
    'menu.conversation.sessions': 'Sessions & Replay',
    'menu.platform': 'Devices & Tenants',
    'menu.platform.devices': 'Devices',
    'menu.platform.tenants': 'Tenants',
    'menu.platform.apps': 'Apps',
    'menu.platform.apiKeys': 'API Keys',
    'menu.model.channels': 'Model Channels',
    'menu.skill.registry': 'Skill Registry',
    'menu.skill.tools': 'MCP & Tools',
    'menu.knowledge.base': 'Knowledge Base',
    'menu.speech': 'Speech & TTS',
    'menu.speech.dialogue': 'Dialogue Chain Wizard',
    'menu.speech.asr': 'ASR Providers',
    'menu.speech.tts': 'TTS Voices',
    'menu.speech.transcription': 'Transcription',
    'menu.speech.voiceprint': 'Voiceprint',
    'menu.speech.analysis': 'Voice Analysis',
    'menu.speech.voiceclone': 'Voice Clone',
    'menu.log.invocation': 'Invocation Logs',
    'menu.system.settings': 'System Settings',
    'menu.user.info': 'User Info',
    'menu.user.setting': 'User Setting',
    'menu.user.switchRoles': 'Switch Roles',
    'menu.user.role.admin': 'Admin',
    'menu.user.role.user': 'General User',
    'navbar.logout': 'Logout',
    'settings.title': 'Settings',
    'settings.themeColor': 'Theme Color',
    'settings.content': 'Content Setting',
    'settings.navbar': 'Navbar',
    'settings.menuWidth': 'Menu Width (px)',
    'settings.navbar.theme.toLight': 'Click to use light mode',
    'settings.navbar.theme.toDark': 'Click to use dark mode',
    'settings.menu': 'Menu',
    'settings.footer': 'Footer',
    'settings.otherSettings': 'Other Settings',
    'settings.colorWeek': 'Color Week',
    'settings.alertContent': 'After the configuration is only temporarily effective, if you want to really affect the project, click the "Copy Settings" button below and replace the configuration in settings.json.',
    'settings.copySettings': 'Copy Settings',
    'settings.copySettings.message': 'Copy succeeded, please paste to file src/settings.json.',
    'settings.close': 'Close',
    'settings.color.tooltip': '10 gradient colors generated according to the theme color',
    'message.tab.title.message': 'Message',
    'message.tab.title.notice': 'Notice',
    'message.tab.title.todo': 'ToDo',
    'message.allRead': 'All Read',
    'message.seeMore': 'SeeMore',
    'message.empty': 'Empty',
    'message.empty.tips': 'No Content',
    'message.lang.tips': 'Language switch to ',
    'navbar.search.placeholder': 'Please search'
  },
  'zh-CN': {
    'menu.dashboard': '仪表盘',
    'menu.dashboard.workplace': '工作台',
    'menu.data.memory': '记忆与画像',
    'menu.data.conversation': '对话与档案',
    'menu.data.device': '设备与人脸',
    'menu.data.actions': 'Action 与自学习',
    'menu.conversation.sessions': '会话检索与回放',
    'menu.platform': '设备与租户',
    'menu.platform.devices': '设备管理',
    'menu.platform.tenants': '租户管理',
    'menu.platform.apps': 'App 管理',
    'menu.platform.apiKeys': 'API Key 管理',
    'menu.model.channels': '模型与渠道',
    'menu.skill.registry': '技能管理',
    'menu.skill.tools': 'MCP 与工具',
    'menu.knowledge.base': '知识库',
    'menu.speech': '语音与合成',
    'menu.speech.dialogue': '对话链路配置',
    'menu.speech.asr': 'ASR 配置',
    'menu.speech.tts': 'TTS 配置',
    'menu.speech.transcription': '语音转写',
    'menu.speech.voiceprint': '声纹注册',
    'menu.speech.analysis': '语音分析',
    'menu.speech.voiceclone': '一句话复刻',
    'menu.log.invocation': '调用日志',
    'menu.system.settings': '系统设置',
    'menu.user.info': '用户信息',
    'menu.user.setting': '用户设置',
    'menu.user.switchRoles': '切换角色',
    'menu.user.role.admin': '管理员',
    'menu.user.role.user': '普通用户',
    'navbar.logout': '退出登录',
    'settings.title': '页面配置',
    'settings.themeColor': '主题色',
    'settings.content': '内容区域',
    'settings.navbar': '导航栏',
    'settings.menuWidth': '菜单宽度 (px)',
    'settings.navbar.theme.toLight': '点击切换为亮色模式',
    'settings.navbar.theme.toDark': '点击切换为暗黑模式',
    'settings.menu': '菜单栏',
    'settings.footer': '底部',
    'settings.otherSettings': '其他设置',
    'settings.colorWeek': '色弱模式',
    'settings.alertContent': '配置之后仅是临时生效，要想真正作用于项目，点击下方的 "复制配置" 按钮，将配置替换到 settings.json 中即可。',
    'settings.copySettings': '复制配置',
    'settings.copySettings.message': '复制成功，请粘贴到 src/settings.json 文件中',
    'settings.close': '关闭',
    'settings.color.tooltip': '根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）',
    'message.tab.title.message': '消息',
    'message.tab.title.notice': '通知',
    'message.tab.title.todo': '待办',
    'message.allRead': '全部已读',
    'message.seeMore': '查看更多',
    'message.empty': '清空',
    'message.empty.tips': '暂无内容',
    'message.lang.tips': '语言切换至 ',
    'navbar.search.placeholder': '输入内容查询'
  }
};
export default i18n;